export default "__VITE_ASSET__BMetQLNG__"